import { ReactNode } from "react"
import _ from 'lodash'
import styled from "@emotion/styled"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FusionColor } from "../../../theme/FusionStyle"
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons"
import { StatusIndicatorProps } from "./StatusIndicatorProps"
import { V2L1LoadingIndicator } from "./V2L1LoadingIndicator"

interface V2L1StatusIndicatorRootProps {
	color?: FusionColor
	coloredLabel?: boolean
	nowrap?: boolean
}

const V2L1StatusIndicatorRoot = styled.div<V2L1StatusIndicatorRootProps>(({
	theme,
	color = FusionColor.Inherit,
	coloredLabel = false,
	nowrap,
}) => ({
	display: 'inline-flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: '0.25em',
	color: coloredLabel ? theme.colors[color] : 'inherit',
	'svg': {
		color: theme.colors[color],
	},
	whiteSpace: nowrap ? 'nowrap' : 'normal',
}))

interface V2L1StatusIndicatorProps extends Partial<StatusIndicatorProps> {
	className?: string
	coloredLabel?: boolean
	nowrap?: boolean
}

export const V2L1StatusIndicator = ({className, icon, color, coloredLabel, nowrap, title}: V2L1StatusIndicatorProps) => {
	let iconNode: ReactNode = null
	if(_.get(icon, 'iconName') === faSpinnerThird.iconName) {
		iconNode = <V2L1LoadingIndicator />
	} else if(icon) {
		iconNode = <FontAwesomeIcon icon={icon} fixedWidth />
	}
	return (
		<V2L1StatusIndicatorRoot className={className} color={color} coloredLabel={coloredLabel} nowrap={nowrap}>
			{iconNode}
			{title ? <div>{title}</div> : null}
		</V2L1StatusIndicatorRoot>
	)
}
